import Handsontable from 'handsontable/base';
import { MutableRefObject } from 'react';
import { convertColWidthsGUtoPx, getColWidthsResizeWidth } from '../tableSizeUtils';

type SyncHotTableColWidthsToContainerArgs = {
    hotInstance: Handsontable.Core | null | undefined;
    tableContentColWidthsGU: number[] | undefined;
    gridSize: number;
    inList: string | null;
    hotTableContainerRef: MutableRefObject<HTMLDivElement | null>;
    getContextZoomScale: () => number;
};

type ManualColumnResizePluginWithMilanoteValues = {
    milanoteValues?: {
        isCurrentlyResizing?: boolean;
    };
};

export const isHotTableColumnResizeInProgress = (hotInstance: Handsontable.Core | null | undefined): boolean => {
    const manualColumnResizePlugin = hotInstance?.getPlugin<'manualColumnResize'>('manualColumnResize');

    return !!(manualColumnResizePlugin as ManualColumnResizePluginWithMilanoteValues | undefined)?.milanoteValues
        ?.isCurrentlyResizing;
};

/**
 * Keeps Handsontable's manual column widths aligned with the current container width.
 */
export const syncHotTableColWidthsToContainer = ({
    hotInstance,
    tableContentColWidthsGU,
    gridSize,
    inList,
    hotTableContainerRef,
    getContextZoomScale,
}: SyncHotTableColWidthsToContainerArgs): void => {
    if (!hotInstance || !tableContentColWidthsGU) return;

    const resizeToWidth = getColWidthsResizeWidth(inList, hotTableContainerRef, getContextZoomScale);
    const tableContentColWidthsPx = convertColWidthsGUtoPx(tableContentColWidthsGU, gridSize, resizeToWidth);
    const manualColumnResizePlugin = hotInstance.getPlugin<'manualColumnResize'>('manualColumnResize');

    if (!tableContentColWidthsPx || !manualColumnResizePlugin) return;

    let isUpdated = false;
    tableContentColWidthsPx.forEach((colWidthPx, index) => {
        const currentColWidthPx = hotInstance.getColWidth(index);

        if (currentColWidthPx === colWidthPx) return;

        manualColumnResizePlugin.newSize = manualColumnResizePlugin.setManualSize(index, colWidthPx);
        isUpdated = true;
    });

    if (!isUpdated) return;

    requestAnimationFrame(() => {
        if (!hotInstance || hotInstance.isDestroyed) return;

        hotInstance.render();
    });
};
